import React from "react";
import TableHeader from "@components/TableHeader";
import Printfiled from "./Printfiled";

const Package = (props) => {
  const header = [
    {
      title: "tarif_date",
      width: 7,
      align: "left",
      filed: "date",
    },
    {
      title: "availability",
      width: 8,
      align: "center",
      filed: "pax_available",
    },
    {
      title: "base_amount",
      width: 18,
      align: "center",
      filed: "base_amount",
      filedList: ["adult_price", "child_price", "baby_price", "senior_price"],
    },
    {
      title: "charge",
      width: 18,
      align: "center",
      filed: "charge",
      filedList: ["adult_price", "child_price", "baby_price", "senior_price"],
    },
    {
      title: "amount_traveler",
      width: 18,
      align: "center",
      filed: "amount_traveler",
      filedList: ["adult_price", "child_price", "baby_price", "senior_price"],
    },
    {
      title: "you_earn",
      width: 18,
      align: "center",
      filed: "you_earn",
      filedList: ["adult_price", "child_price", "baby_price", "senior_price"],
    },
    { title: "", width: 5, align: "center", filed: "is_stop_sales" },
    { title: "", width: 5, align: "center", filed: "button" },
  ];
  return (
    <>
      <p className="mt-1 fw-normal">{props.t("ho_act_Opt_TarifTxt1")}</p>
      <div class="tableFixHead">
        <table>
          <TableHeader header={header} />
          <tbody>
            {props.prices.map((item, index) => (
              <tr>
                {header.map((head) => (
                  <td style={{ textAlign: head.align }}>
                    <Printfiled
                      tarif={item}
                      filed={head.filed}
                      filedList={head?.filedList}
                      onStopSales={props.onStopSales}
                      priceForm={props.priceForm}
                      config={props.config}
                      dataIndex={{
                        item: item,
                        index: item,
                      }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Package;
